export default __webpack_public_path__ + "static/media/cg_wide_map_big.56924c79.png";